import { render, staticRenderFns } from "./ForeignIndicesForm.vue?vue&type=template&id=acfb1c8c&scoped=true"
import script from "./ForeignIndicesForm.vue?vue&type=script&lang=js"
export * from "./ForeignIndicesForm.vue?vue&type=script&lang=js"
import style0 from "./ForeignIndicesForm.vue?vue&type=style&index=0&id=acfb1c8c&prod&lang=scss&scoped=true"
import style1 from "./ForeignIndicesForm.vue?vue&type=style&index=1&id=acfb1c8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfb1c8c",
  null
  
)

export default component.exports